import { useMemo } from 'react';
import { logScaleEntityPivot } from '@investigator/shared/utils';
import { useDateRangeQueryString } from '@investigator/shared/hooks';

interface UseLogScaleEntityQueryProps {
  entityName?: string;
}

/**
 * Custom hook to generate a LogScale entity query string for navigation
 * @param entityName - The entity name to query (e.g., IP address, hostname)
 * @returns The formatted query string for LogScale, or empty string if invalid
 */
export const useLogScaleEntityQuery = ({
  entityName,
}: UseLogScaleEntityQueryProps): string => {
  const { start, end } = useDateRangeQueryString();

  const logScaleEntityQuery = useMemo(
    () =>
      start && end && entityName
        ? logScaleEntityPivot({
            start,
            end,
            entityName,
          })
        : '',
    [start, end, entityName],
  );

  return logScaleEntityQuery;
};
